<template>
  <div>
    <DormList :dorms="dorms" v-if="dorms"/>
    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading>

<!--     <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading> -->
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
      <ContentLoader v-if="!dorms">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="0" rx="3" ry="3" width="94" height="110" />

        <rect x="3" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="115" rx="3" ry="3" width="94" height="110" />
      </ContentLoader>
  </div>
</template>

<script>
import DormList from '@/components/DormList'
import FixedPopup from '@/components/FixedPopup'
import InfiniteLoading from 'vue-infinite-loading'
import { ContentLoader } from 'vue-content-loader'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'CityGender',
  components: {
    DormList,
    FixedPopup,
    InfiniteLoading,
    ContentLoader
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]
    }
  },
  data () {
    return {
      url: '',
      page: 1,
      total: 0,
      dorms: null,
      errors: [],
      gender: '',
      typeID: null,
      popupDorms: null,
      infiniteId: +new Date(),
      emptyContent: {
        icon: 'icon-search',
        title: 'Sonuç Bulunamadı!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      }
    }
  },
  methods: {
    infiniteHandler ($state) {
      this.checkGender()
      let self = this
      axios
        .get(`/site/cities/dorms/${this.$route.params.city}?dorm_type=${self.typeID}&page=${this.page}`)
        .then(({ data }) => {
          if (data.data.data) {
            self.page += 1
            // this.$router.replace('Page=' + this.page, { silent: true })
            if (Array.isArray(self.dorms) && Array.isArray(data.data.data) !== true && Object.keys(data.data.data).length !== 0) {
              Object.keys(data.data.data).forEach(item => {
                self.dorms.push(data.data.data[item])
              })
              $state.loaded()
            } else if (!self.dorms && Array.isArray(data.data.data)) {
              self.dorms = data.data.data
              $state.loaded()
            } else {
              $state.complete()
            }
            self.total = data.data.total
            self.popupDorms = data.data.popups
          } else {
            $state.complete()
          }
        })
    },
    checkGender () {
      const type = this.$attrs.redirect ? this.$route.params.slug : this.$route.params.type
      if (type && type.includes('erkek')) {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (type && type.includes('kiz')) {
        this.gender = 'Kız'
        this.typeID = 2
      }
    },
    getDorms () {
      this.checkGender()
      let self = this
      const url = self.$attrs.redirect ? `/site/cities/dorms/${this.$route.params.city}?dorm_type=${self.typeID}&page=1` : `/site/cities/dorms/${this.$route.params.city}?dorm_type=${self.typeID}&page=1`
      axios.get(url)
        .then(response => {
          // self.pagination = response.data.data
          self.dorms = response.data.data.data
          self.total = response.data.data.total
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['cityDetails']),
    pageTitle () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_title
        else if (this.typeID === 2) title = this.cityDetails.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_description
        else if (this.typeID === 2) title = this.cityDetails.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.cityDetails) {
        if (this.typeID === 1) title = this.cityDetails.male_keywords
        else if (this.typeID === 2) title = this.cityDetails.female_keywords
      }
      return title
    }
  },
  mounted () {
    // this.getDorms()
  },
  watch: {
    $route () {
      this.checkGender()
      // this.getDorms()
      this.page = 1
      this.dorms = null
      this.infiniteId += 1
      this.url = window.location.origin + this.$route.fullPath
    }
  },
  created () {
    // this.getDorms()
    this.url = window.location.origin + this.$route.fullPath
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/components/city";
  @import "../../assets/scss/components/pagination-new";

  /*.info-card {*/
    /*height: auto !important;*/
  /*}*/

  .wrapper {
    padding-bottom: 170px;
  }

  .dorm-tab__header {
    margin-top: -90px;
  }

  .select__title {
    font-size: 17px !important;
  }
  .city-text p {
    color: #fff !important;
  }
</style>
